var t=function(t){return t.ExcelXlsx="ExcelXlsx",t.Csv="Csv",t.Txt="Txt",t}({});export{t as ReportExportFormat};
//# sourceMappingURL=report.js.map